import { z } from 'zod';
import { RowVersionSchema } from '../common/row-version.js';
// api_clients as returned to sysadmins (ADR-004). key_hash and
// previous_key_hash are NEVER part of any response shape by construction; the
// only credential fragment ever re-displayed is key_hint (the secret's last 4
// chars). The full secret appears exactly once, in the create / rotate response.
export const ApiClientSchema = z
    .object({
    row_version: RowVersionSchema,
    id: z.string().max(16),
    name: z.string().max(64),
    description: z.string().nullable(),
    // Reach: one project (id + display name resolved for the surface), or null =
    // fleet (every project).
    project_id: z.string().max(16).nullable(),
    project_name: z.string().nullable(),
    permissions: z.array(z.string()),
    on_behalf_permissions: z.array(z.string()),
    device_target_kinds: z.array(z.string()),
    key_hint: z.string().max(4).nullable(),
    // Rotation-overlap state — non-null while an old key is still accepted.
    previous_key_expires_at: z.string().datetime().nullable(),
    previous_key_last_used_at: z.string().datetime().nullable(),
    last_used_at: z.string().datetime().nullable(),
    last_used_ip: z.string().nullable(),
    created_at: z.string().datetime(),
    rotated_at: z.string().datetime().nullable(),
    revoked_at: z.string().datetime().nullable(),
})
    .strict();
export const ApiClientsListResponseSchema = z.object({ items: z.array(ApiClientSchema) }).strict();
export const ApiClientDetailResponseSchema = ApiClientSchema;
// The show-once shapes: `secret` is the full raw credential (`emsk_…`) — returned
// here and NEVER again (the DB holds only its hash + hint).
export const CreatedApiClientResponseSchema = z
    .object({ client: ApiClientSchema, secret: z.string() })
    .strict();
export const RotatedApiClientResponseSchema = z
    .object({ client: ApiClientSchema, secret: z.string() })
    .strict();
